import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './CardContainer.css';

const CardContainer = ({ children }) => (
  <div className={styles.cardContainer}>{children}</div>
);

CardContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};

export default CardContainer;



// WEBPACK FOOTER //
// ./src/components/CardContainer.jsx